// extracted by mini-css-extract-plugin
module.exports = {"widget":"widget-blind_widget__vxthp"};